import { ColumnDef } from "@tanstack/react-table";
import ReportCard from "components/cards/ReportCard";
import PageBreadcrumb from "components/common/PageBreadcrumb";
import { reportsBreadcrumbItems } from "data/commonData";
import { Report, reports } from "data/crm/reportsData";
import useAdvanceTable from "hooks/useAdvanceTable";
import AdvanceTableProvider from "providers/AdvanceTableProvider";
import { Col, Row } from "react-bootstrap";
import ReportTopSection from "components/modules/crm/ReportTopSection";
import AdvanceTableFooter from "components/base/AdvanceTableFooter";
import { atom, useAtom } from "jotai";
import { useEffect, useState } from "react";

export const columns: ColumnDef<Report>[] = [
  {
    id: "priority",
    accessorFn: ({ priority }) => priority.label,
  },
  {
    id: "category",
    accessorFn: ({ category }) => category,
  },
  {
    accessorKey: "title",
  },
];
interface UserInfo {
  email: string;
}
const user_info = atom<UserInfo>({ email: "" });

const Reports = () => {
  const [userInfo] = useAtom<UserInfo>(user_info);
  const [showDeals, setShowDeals] = useState(true);
  const isAuthorized = userInfo?.email === "michael@kairosiq.ai";
  const table = useAdvanceTable<Report>({
    data: reports,
    columns,
    pageSize: 10,
    pagination: true,
    sortable: true,
  });
  useEffect(() => {
    if (!isAuthorized) {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === "childList") {
            const backdropExists = document.getElementById("kairos-backdrop");
            if (!backdropExists) {
              setShowDeals(false);
            }
          }
        });
      });
      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
      return () => observer.disconnect();
    }
  }, [isAuthorized]);
  return (
    <>
      {/* {(isAuthorized || showDeals) && ( */}
      <div>
        <PageBreadcrumb items={reportsBreadcrumbItems} />
        <AdvanceTableProvider {...table}>
          <div className="mb-9">
            <h2 className="mb-4">Reports</h2>
            <ReportTopSection />
            <Row className="g-3">
              {table
                .getRowModel()
                .rows.map((row) => row.original)
                .map((report) => (
                  <Col xl={6} key={report.id}>
                    <ReportCard report={report} />
                  </Col>
                ))}
            </Row>
            <AdvanceTableFooter pagination className="mt-2 pb-0" />
          </div>
        </AdvanceTableProvider>
      </div>
      {/* )} */}
      {/* {!isAuthorized && <Backdrop />} */}
    </>
  );
};

export default Reports;
